export const getFieldArrayErrorMessage = (
  name: string,
  index: number,
  error: Array<any> | undefined
) => {
  return error?.[index]?.[name]?.message;
};
